export enum Action {
  Save = 1,
  Submit,
  SaveAsDraft,
  SaveWithCloneRemoval
}
